import { h } from 'preact';

export function WedgelockConfigure() {
  return (
    <div class="purchase-block__wedgelock-configure">
      <a class='button button--secondary' href='#wedgelok-configure'>
        {(window as any).Drupal.t('Customize')}
        <svg class="icon js-icon-exists" aria-hidden="true" role="img">
          <use xlinkHref={`/themes/custom/particle/dist/app-drupal/assets/images/sprite.svg#sprite-gear`}></use>
        </svg>
      </a>
    </div>
  );
}
